import React from "react";
import classNames from "classnames";

import getStrainQuizMatchTier from "./getStrainQuizMatchTier";

type Props = {
  strainMatch: number;
};

const StrainMatchLabel = ({ strainMatch }: Props) => {
  const { backgroundClasses } = getStrainQuizMatchTier(strainMatch);

  return (
    <div
      className={classNames(
        backgroundClasses,
        "absolute flex shadow-low flex-col justify-center rounded-full h-[54px] lg:h-[64px] w-[54px] lg:w-[64px] top-[60px] lg:top-[120px] lg:left-[20px] pt-xs lg:pt-sm z-10",
      )}
      data-testid="strain-match-label"
    >
      <span className="flex justify-center w-[54px] lg:w-[64px] filter font-extrabold leading-none text-center text-xs lg:text-md">
        {strainMatch}%
      </span>
      <p className="flex justify-center w-[54px] lg:w-[64px] leading-none text-xs">
        match
      </p>
    </div>
  );
};

export default StrainMatchLabel;
